import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';
import type { Action } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { SessionState } from '../../account/sessionReducer';
import type { EditorState } from '../../editor/editorReducer';
import type { OnboardingState } from '../../onboarding/onboardingReducer';
import type { UIState } from '../../ui/uiReducer';

export interface RootState {
  editor: EditorState;
  onboarding: OnboardingState;
  session: SessionState;
  ui: UIState;
}

export type Dispatch = ThunkDispatch<RootState, void, Action>;

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
